import { useState, useEffect, useContext } from "react";
import { notify } from "../utils/utils";
import { AuthFetch } from "../services/api";
import { useModal } from './useModal';
import { useSpinner } from "./useSpinner";
import { set } from "date-fns";

const urlBasePlamin = process.env.REACT_APP_PLAMIN_API + "/api";

export const useUsuariosAplicativo = () => {
    const usuarioDefault = {
        codUsuarioEstado:0,
        codUsuarioOAuth: 0,
        nomUsuario: '',
        correoPrincipal: '',
        nomPersona: '',
        numeroDocumento: '',
        numCelularPrincipal: '',
        fechaRegistro:'',
        codEstado: 0,
        motivoCambioEstado:''    
    }
    const usuarioAnularDefault = {
        uidAnular: "",
        nomUsuarioAnular: "",
        motivoAnular: ""
    }
    const [ usuarios, setUsuarios ] = useState([]);
    const [ usuario, setUsuario ] = useState(usuarioDefault);
    const [ usuarioAnular, setUsuarioAnular ] = useState(usuarioAnularDefault)
    const [ spinner, mostrarSpinner, ocultarSpinner ] = useSpinner();
    const [ isOpen, openModal, closeModal] = useModal();
    const [ isOpenCambiarEstado, openModalCambiarEstado, closeModalCambiarEstado] = useModal();

    const listarUsuarios = async (tipoUsuario) => {
        try
        {
            mostrarSpinner();
            const response = await AuthFetch('/User/userLdap?'+ new URLSearchParams({
                group: tipoUsuario
            }))
            if (response.isValid){
                setUsuarios(response.content);
            }
            else{
                setUsuarios([]);
                notify(response.exceptions[0].description, 'error');
            }
            ocultarSpinner()

        }
        catch(error)
        {
            setUsuarios([]);
            notify('Ocurrió un error en el servicio','error');
        }
    }

    const listarEstadosUsuarios = async () => {
        mostrarSpinner();
        const response = await AuthFetch('/User/listarEstadosUsuario?' + new URLSearchParams({
        }), {
            method: 'GET'
        })
        if (response.isValid) {
            setUsuarios(response.content)
        } else {
            notify(response.exceptions[0].description, 'error')
        }
        ocultarSpinner()
    }

    const obtenerUsuario = async (codUsuarioOAuth) => {
        if (codUsuarioOAuth){
            const response = await AuthFetch('/User/obtenerUsuarioPorCodUsuario?'+ new URLSearchParams({
                codUsuario :codUsuarioOAuth
            }),{
                method: 'GET',
            })
            setUsuario(response.content)
        }else{
            setUsuario(usuarioDefault);
        }
        openModal();
    }

    const obtenerUsuarioCambiarEstado = async (codUsuarioOAuth) => {
        if (codUsuarioOAuth){
            const response = await AuthFetch('/User/obtenerUsuarioPorCodUsuario?'+ new URLSearchParams({
                codUsuario :codUsuarioOAuth
            }),{
                method: 'GET',
            })
            setUsuario(response.content)
        }else{
            setUsuario(usuarioDefault);
        }
        openModalCambiarEstado();
    }
    
    const cambiarEstadoUsuario = async () =>{
        const response = await AuthFetch({
            url : urlBasePlamin + '/usuario/eliminarUsuario',
            method : 'POST',
            body : JSON.stringify({
                codUsuario: usuario.codUsuarioOAuth,
                codEstado: usuario.codEstado,
                motivoEliminacion: usuario.motivoCambioEstado
            })
        })
        notify(response.content, response.isValid? 'success' : 'error');
        if (response.isValid){
            await listarUsuarios();
            closeModal()
        }
    }
    
    const editarValorUsuario = (key,value) =>{
        setUsuario(usuario => {
            return {
                ...usuario,
                [key]: value
            }
        });
    }     
    
    const anularUsuario = async () => {
        mostrarSpinner();
        const response = await AuthFetch('/User', {
            method: 'DELETE',
            body: JSON.stringify({
                uidEliminado: usuarioAnular.uidAnular,
                comentario: usuarioAnular.motivoAnular
            })
        })
        notify((response.isValid ? response.content : response.exceptions[0].description), response.isValid ? 'success' : 'error')
        ocultarSpinner()
        return response.isValid;
    }

    const removerRolUsuario = async (rol) => {
         mostrarSpinner();
        const response = await AuthFetch('/User/removeUserFromGroup', {
            method: 'DELETE',
            body: JSON.stringify({
                rolLdap: rol,
                userLdap: usuarioAnular.uidAnular,
                comentario: usuarioAnular.motivoAnular
            })
        })
        notify((response.isValid ? response.content : response.exceptions[0].description), response.isValid ? 'success' : 'error')
        ocultarSpinner()
        return response.isValid;
    }

    const editarValorAnularUsuario = (key, value) => {
        setUsuarioAnular(usuarioAnular => {
            return {
                ...usuarioAnular,
                [key] : value
            }
        })
    }
    return {
        usuarios,
        listarUsuarios,
        setUsuario,
        usuario,
        editarValorUsuario,
        obtenerUsuario,
         spinner,
         isOpen,
        openModal,
        closeModal,
        cambiarEstadoUsuario,
        isOpenCambiarEstado,
        closeModalCambiarEstado,
        obtenerUsuarioCambiarEstado,
        listarEstadosUsuarios,
        anularUsuario,
        editarValorAnularUsuario,
        usuarioAnular,
        removerRolUsuario
    };
}